<template>
    <div id="main">
        <loader v-if="isLoading" />
        <div class="page page-container">
            <!-- CONTAINER DE ALERTAS -->
            <alert-container :messages="msgs" />

            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t('moeda') }}
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{ $t('despesas') }}</a>
                                </li>
                                <li>
                                    <a @click="$router.push({ name: `${abrev}-moeda` })">{{
                                        $t('moedas')
                                    }}</a>
                                </li>
                                <li>
                                    <a aria-current="page">{{
                                        $route.params.id ? $route.params.id : $t('novo')
                                    }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="$router.push({ name: `${abrev}-moeda` })"
                        >
                            {{ $t('voltar') }}
                        </button>
                        <button
                            v-if="
                                (!usuarioIntegracao && !isUpdate && permissao.create) ||
                                (!usuarioIntegracao && isUpdate && permissao.update)
                            "
                            class="save-btn"
                            type="button"
                            @click="save"
                            :disabled="isSaving"
                        >
                            {{ $t('salvar') }}
                            <button-loader :isSaving="isSaving" />
                        </button>
                    </div>
                </div>
                <br />
                <div class="form-columns-fit">
                    <div class="columns is-flex-wrap">
                        <div class="column is-2">
                            <v-input
                                :id="generateId(9)"
                                ref="idErpInput"
                                v-model="moeda.idmoedaerp"
                                placeholder="placeholder-preencha"
                                :maxlength="30"
                                title="codigo"
                                uppercase
                                required
                                tooltipLabel="cod-ref"
                                :invalid="!moeda.idmoedaerp"
                                :disabled="usuarioIntegracao"
                            />
                        </div>
                        <div class="column is-5">
                            <v-input
                                :id="generateId(1)"
                                ref="descricaoInput"
                                v-model="moeda.descricao"
                                placeholder="placeholder-preencha"
                                :maxlength="50"
                                msg="msg-campo-obrigatorio"
                                :invalid="!moeda.descricao"
                                uppercase
                                title="descricao"
                                tooltipLabel="informacao-descricao-moeda"
                                tooltipPosition="is-right"
                                tooltipSize="is-small"
                                :tooltipMultilined="true"
                                :required="true"
                                :disabled="usuarioIntegracao"
                            />
                        </div>
                        <div class="column is-3">
                            <v-input
                                :id="generateId(2)"
                                ref="simboloMonetarioInput"
                                v-model="moeda.simbolomonetario"
                                placeholder="placeholder-preencha"
                                :maxlength="50"
                                msg="msg-campo-obrigatorio"
                                :invalid="!moeda.simbolomonetario"
                                uppercase
                                title="simbolomonetario"
                                tooltipLabel="informacao-simbolomonetario-moeda"
                                tooltipPosition="is-right"
                                tooltipSize="is-small"
                                :tooltipMultilined="true"
                                :required="true"
                                :disabled="usuarioIntegracao"
                            />
                        </div>
                        <div class="column is-2">
                            <vss-select
                                :id="generateId(3)"
                                ref="situacaoSelect"
                                :searchable="false"
                                :options="situacoes"
                                v-model="situacao"
                                class="no-clear"
                                :mlLabels="true"
                                :disabled="moeda.id == null || usuarioIntegracao"
                                title="situacao"
                                tooltipLabel="informacao-situacao-moeda"
                                :tooltipPosition="isMobile ? 'is-right' : 'is-left'"
                                tooltipSize="is-small"
                                :tooltipMultilined="true"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MoedaService from '@/services/vendas/MoedaService';
import MoedaValidation from '@/services/validations/vendas/MoedaValidation';
import Message from '@/models/Message';

export default {
    data() {
        return {
            usuarioIntegracao: this.$store.state.user.tabelasERPWebServer.includes('MOEDA'),
            service: new MoedaService(this.$http, this.$router),
            isLoading: false,
            msgs: [],
            isSaving: false,
            validation: new MoedaValidation(this.msgs),
            moeda: {
                id: null,
                idmoedaerp: null,
                descricao: null,
                simbolomonetario: null,
                situacao: null,
            },
            isUpdate: false,
            situacoes: [
                { label: 'inativo', id: 0 },
                { label: 'ativo', id: 1 },
            ],
            situacao: { label: 'ativo', id: 1 },
            isMobile: false,
            abrev: this.$route.meta.contexto.slice(0, 3),
        };
    },
    created() {
        if (this.$route.params.id) this.isUpdate = true;

        this.permissao =
            this.$route.meta.contexto == 'vendas'
                ? this.hasPermissionAccess('vendas', 'vendas', 'ven-moeda')
                : this.hasPermissionAccess('despesas', 'empresa', 'des-moeda');

        if (!this.isUpdate && !this.permissao.create) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'moeda' },
            });
        } else {
            if (this.$route.params.id) {
                this.carregarDados(this.$route.params.id);
                this.isUpdate = true;
            }
        }
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + '-' + numberId;
        },
        carregarDados(id) {
            this.isLoading = true;
            this.service
                .find(id)
                .then((value) => {
                    this.moeda = value.content;
                    this.situacao = this.situacoes[this.moeda.situacao];
                    if (!this.situacao) {
                        this.situacao = this.situacoes[1];
                    }
                })
                .catch((e) => {
                    this.msgs.push(new Message('error', 'msg-erro-load', true));
                })
                .finally((_) => {
                    this.isLoading = false;
                });
        },
        save() {
            this.isLoading = true;

            if (this.validation.validate(this.moeda, this.$refs)) {
                let moedaTemp = Object.assign({}, this.moeda);
                moedaTemp = this.mapTosave(moedaTemp);
                moedaTemp.descricao = this.moeda.descricao;
                moedaTemp.simbolomonetario = this.moeda.simbolomonetario;
                moedaTemp.situacao = this.situacao.id;

                this.isSaving = true;
                this.service
                    .save(moedaTemp)
                    .then((value) => {
                        if (value.message == null) {
                            let msg = 'moeda-cadastrada-sucesso';
                            if (this.moeda.id != null) {
                                msg = 'moeda-editada-sucesso';
                            }
                            this.msgs.push(new Message('success', msg, true));
                            this.redirectToList();
                        } else {
                            if (this.$te(value.message)) {
                                this.msgs.push(new Message('alert', value.message, true));
                            } else {
                                this.msgs.push(
                                    new Message('error', 'msg-problema-realizar-acao', true)
                                );
                            }
                        }
                    })
                    .catch((e) => {
                        let message = e.body.message;
                        if (message && this.$te(message)) {
                            if (message == 'msg-codigo-duplicado-n') {
                                this.msgs.push(
                                    new Message(
                                        'warning',
                                        this.$t(message, { n: moedaTemp.idmoedaerp }),
                                        true,
                                        false
                                    )
                                );
                            } else {
                                this.msgs.push(new Message('alert', message, true));
                            }
                        } else {
                            this.msgs.push(
                                new Message('error', 'msg-problema-realizar-acao', true)
                            );
                        }
                    })
                    .finally(() => {
                        this.isSaving = false;
                        this.isLoading = false;
                    });
            } else {
                this.msgs.push(new Message('alert', 'msg-campos-obrigatorios', true));
                this.isLoading = false;
            }
        },
        redirectToList() {
            setTimeout(() => {
                this.$router.push({
                    name: `${this.abrev}-moeda`,
                });
            }, 1000);
        },
    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;

    .page {
        position: relative;
    }
    #color {
        padding: 0 !important;
        height: 36px;
        cursor: pointer;
    }
}
</style>
